import {
    keyIssueSelectPermissionHolderType,
    keyIssueRemoveOwnerViewer,
    keyIssueSearchAddOwnersViewers,
    keyIssueApplyAddOwnersViewers,
    keyIssueSelectAddOwnerViewer,
    keyIssueCancelAddOwnersViewers
} from "../../../../actions/key-issue-actions"

import buildPermissionHoldersConnector from "../../../common/permission-holders/build-permission-holders-connector"
import PermissionHoldersEditWidget from "../../../common/permission-holders/PermissionHoldersEditWidget"

export default buildPermissionHoldersConnector(
    "keyIssues",
    keyIssueSelectPermissionHolderType,
    keyIssueRemoveOwnerViewer,
    keyIssueSearchAddOwnersViewers,
    keyIssueSelectAddOwnerViewer,
    keyIssueApplyAddOwnersViewers,
    keyIssueCancelAddOwnersViewers
)(PermissionHoldersEditWidget)
